<template>
  <div id="formTable">
    <Form :model="tableForm" :label-width="80" style="margin: 10px 0 0px 0">
      <Row v-show="!hideTime">
        <Col span="24" style="display: flex">
          <slot name="duration"></slot>
          <time-tool
            @timeObj="reTimeObj"
            ref="timeTool"
            :timeModel="timeModel"
            :day0="day0"
          ></time-tool>
        </Col>
      </Row>
    </Form>
    <div id="ddas">
      <template>
        <Button
        type="primary"
        size="small"
        @click="openCarDrawer = true"
        icon="md-funnel"
         v-if="!hideFill"
        >筛选</Button
      >
      <Button
        @click="daochu"
        size="small"
        icon="md-arrow-down"
        v-if="!hideExport"
        >导出</Button
      >
      </template>
      
      <slot name="btn"></slot>
    </div>
    <Drawer
      placement="right"
      :closable="true"
      :mask="false"
      v-model="openCarDrawer"
      width="470"
      draggable
    >
      <div id="asekuychss">
        <RadioGroup v-model="clbj" type="button" button-style="solid" size="small">
          <Radio :label="1" :disabled="!model1.includes(1)">筛选车辆</Radio>
          <Radio :label="2" :disabled="!model1.includes(2)">筛选报警</Radio>
          <Radio :label="3" :disabled="!model1.includes(3)">筛选司机</Radio>
        </RadioGroup>
      </div>
      <div id="trdscg" v-show="clbj == 1">
        <car-tool :isMore="true" @cars="reCarLists"></car-tool>
      </div>
      <div v-show="clbj == 2" id="lysuclk">
        <alarm-tool
          @alarmData="reAlarmData"
          :alarmFill="alarmFill"
        ></alarm-tool>
      </div>
      <div v-show="clbj == 3" id="lysuclk">
        <driver-tool :isMore="true" @drivers="redriverLists"></driver-tool>
      </div>
    </Drawer>
  </div>
</template>
<script>
import carTool from "./carTool.vue";
import alarmTool from "./alarmTool.vue";
import driverTool from "./driverTool.vue";
export default {
  props: ["model", "hideExport", "hideTime", "timeModel", "day0", "alarmFill","hideFill"],
  components: { carTool, alarmTool, driverTool },
  data() {
    return {
      clbj: this.model == undefined ? 1 : Number(this.model[0]),
      model1: this.model || "1",
      tableForm: {
        carNo: 1,
      },
      openCarDrawer: false,
    };
  },
  methods: {
    daochu() {
      var t = this.timeObj;
      var limit = 31;
      if (t.end - t.start > 86400000 * limit) {
        this.$Message.error({
          content: "暂时只能导" + limit + "天内数据",
          duration: 3,
        });
        return false;
      }
      this.$emit("exportAll");
    },
    reCarLists(v) {
      this.$emit("carList", v);
    },
    redriverLists(v) {
      this.$emit("driverList", v);
    },
    reAlarmData(v) {
      this.$emit("alarmData", v);
    },
    reTimeObj(v) {
      this.timeObj = v;
      this.$emit("timeObj", v);
    },
  },
  mounted() {
    /* if (this.model==undefined) {
      this.model1=1;
    }else{
      //this.model1=this.model
    } */
  },
  deactivated() {
    this.openCarDrawer = false;
  },
};
</script>
<style lang="">
#asekuychss {
  width: 100%;
  height: 40px;
}

#lysuclk {
  height: calc(100% - 40px);
}
#trdscg {
  height: calc(100% - 40px);
}
</style>


// WEBPACK FOOTER //
// src/components/common/reportTools.vue